import React, {useMemo} from 'react';
import debounce from 'debounce';
import {usePagination, useTable} from 'react-table';
import DataTableView from './DataTable-view';

const DELAY = 450;

const DataTable = ({
                     data: tableData,
                     totalPages,
                     totalResultCount,
                     page,
                     setPage,
                     columnsList,
                     loading
                   }) => {
  const data = useMemo(() => [...tableData], [tableData]);
  const columns = useMemo(() => [...columnsList], []);
  const tableProps = useTable(
    {
      columns,
      data,
      initialState: {pageIndex: page},
      manualPagination: true,
      pageCount: totalPages,
    },
    usePagination
  );

  const gotoPage = pageIndex => {
    setPage(pageIndex);
    tableProps.gotoPage(pageIndex);
  };

  const nextPage = debounce(() => {
    setPage(page + 1);
    tableProps.nextPage();
  }, DELAY);

  const previousPage = debounce(() => {
    setPage(page - 1);
    tableProps.previousPage();
  }, DELAY);

  const customTableProps = {
    ...tableProps,
    gotoPage,
    nextPage,
    pageIndex: page,
    previousPage,
    totalResultCount,
    showPagination: true,
    allowSorting: false,
    loading
  };

  return (
    <DataTableView {...customTableProps} />
  );
};

export default DataTable;